import EnglishTitleImage from 'assets/images/img_title_eng.png';
import TitleImage from 'assets/images/img_title.png';
import styled from 'styled-components';
import ShareIcon from 'assets/icons/ic_share.png';
import { useSnackbar } from 'hooks/useSnackbar';
import { useClipboardCopy } from 'hooks/useClipboardCopy';
import { useEffect } from 'react';
import Snackbar from './Snackbar';
import i18n, { t } from 'i18next';
import { LanguageType } from 'scheme/languageType';
import { useSendToApp } from 'hooks/useSendToApp';
import { event } from 'react-ga';
import { parseLanguageType } from 'utils/parseLanguageType';

export default function Title() {
  const { isShowedUp, showSnackbar, closeSnackbar } = useSnackbar();
  const { handleClipboardCopy, isCopied, setIsCopied } = useClipboardCopy();
  const { sendToApp } = useSendToApp();

  const handleShareClick = () => {
    event({
      category: 'click_share',
      action: 'Click share',
    });

    try {
      if (parseLanguageType(i18n.language) == LanguageType.KO)
        shareToNative({
          title: '너랑 나랑 꽁냥템 같이 쓰자 🥰\n',
          text: '특별한 커플템 선물하고 달콤한 일상을 함께하세요!\n',
          url: 'https://event-couple.plkey.app',
        });
      else {
        shareToNative({
          title: 'Let’s use lovey-dovey item together 🥰\n',
          text: 'Present a special couple item and share a sweet daily life!\n',
          url: 'https://event-couple.plkey.app',
        });
      }
    } catch (err) {}
  };

  const shareToNative = (data: { title: string; text: string; url: string }) => {
    try {
      return sendToApp('share', `${data.title}${data.text}\n${data.url}`);
    } catch (err) {}
    if (window.navigator.share) {
      return window.navigator.share(data);
    } else {
      handleClipboardCopy(window.location.href);
    }
  };

  useEffect(() => {
    if (!isCopied) return;
    showSnackbar();
    setIsCopied(false);
  }, [isCopied]);

  return (
    <>
      {screen.width <= 650 && <ShareButton src={ShareIcon} onClick={handleShareClick} />}
      <TitleContainer>
        {parseLanguageType(i18n.language) === LanguageType.KO ? (
          <TitleImageBox src={TitleImage} />
        ) : (
          <TitleImageBox src={EnglishTitleImage} />
        )}
      </TitleContainer>
      {isShowedUp && <Snackbar content={t('linkCopied')} confirm={t('confirm')} closeSnackbar={closeSnackbar} />}
    </>
  );
}

const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  z-index: 100;
  pointer-events: none;
  position: relative;
`;

const TitleImageBox = styled.img`
  min-width: 130px;
  z-index: 100;
`;

const ShareButton = styled.img`
  position: fixed;
  width: 12%;
  right: 4%;
  z-index: 200;
`;
